import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import StopWalkingNodePreview from "../../features/sequence/node_previews/StopWalkingNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export interface IStopWalking extends Interaction {
  npcId: string;
}

export const stopWalkingInteraction = (): InteractionFactoryEntity => {
  const view = <></>;

  const create = (): IStopWalking => ({
    id: GetNewGuid(),
    name: "Stop Walking",
    type: InteractionType.StopWalking,
    npcId: "player",
  });

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IStopWalking => {
    const stopWalking = interaction as IStopWalking;
    return {
      ...stopWalking,
      npcId: stopWalking.npcId ?? "player",
    };
  };

  const copy = (interaction: Interaction): IStopWalking => {
    const original = interaction as IStopWalking;
    return {
      ...original,
      id: GetNewGuid(),
    };
  };

  const validateErrors = (interaction: Interaction): string[] => {
    const stopWalking = interaction as IStopWalking;
    if (!stopWalking.npcId?.trim()) return ["Actor is required"];
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext
  ): SearchResultData[] => {
    const stopWalking = interaction as IStopWalking;

    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        searchLookupContext?.getActorSearchTerms(stopWalking.npcId) ??
          stopWalking.npcId
      ),
      takeName,
      interaction,
      "Stop Walking"
    );
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <StopWalkingNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "Stop Walking",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
